import React, { useEffect, useState } from 'react';
import './WelcomeOverlay.css';

function WelcomeOverlay({ onStartTour, onExploreFree }) {
  const [showOverlay, setShowOverlay] = useState(false);
  const [typedName, setTypedName] = useState('');
  const fullName = 'Diptanshu Dhawan';

  useEffect(() => {
    // DEVELOPMENT MODE: Show overlay on every reload
    // TODO: Uncomment localStorage logic before production deploy
    
    // Check if user has visited before
    // const hasVisited = localStorage.getItem('portfolio_visited');
    
    // if (!hasVisited) {
      // Show overlay after a brief delay
      setTimeout(() => {
        setShowOverlay(true);
        
        // Start typing animation for name only
        setTimeout(() => {
          let nameIndex = 0;
          const nameInterval = setInterval(() => {
            if (nameIndex <= fullName.length) {
              setTypedName(fullName.substring(0, nameIndex));
              nameIndex++;
            } else {
              clearInterval(nameInterval);
            }
          }, 80); // 80ms per character
        }, 500); // Brief delay before name starts typing
      }, 800);
    // }
  }, []);

  const handleStartTour = () => {
    // localStorage.setItem('portfolio_visited', 'true'); // Disabled for development
    setShowOverlay(false);
    onStartTour();
  };

  const handleExploreFree = () => {
    // localStorage.setItem('portfolio_visited', 'true'); // Disabled for development
    setShowOverlay(false);
    onExploreFree();
  };

  const handleClose = () => {
    // localStorage.setItem('portfolio_visited', 'true'); // Disabled for development
    setShowOverlay(false);
    onExploreFree();
  };

  if (!showOverlay) return null;

  return (
    <div className="welcome-overlay-backdrop">
      <div className="welcome-overlay-container">
        <button className="welcome-close" onClick={handleClose}>
          ✕
        </button>
        
        <div className="welcome-terminal">
          <div className="terminal-header">
            <span className="terminal-title">visitor@diptanshu:~$</span>
          </div>
          
          <div className="terminal-content">
            <div className="command-line">
              <span className="prompt">$</span> whoami
            </div>
            
            <div className="whoami-output">
              <div className="output-name">{typedName}<span className="cursor-blink">_</span></div>
              <div className="output-title">Junior Penetration Tester | eJPT Certified</div>
              <div className="output-tagline">Breaking systems to build them stronger.</div>
              
              <div className="output-separator">━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━</div>
              
              <div className="output-description">
                <span className="comment"># This portfolio is an interactive OS environment</span><br />
                <span className="comment"># Choose your path:</span>
              </div>
            </div>

            <div className="cta-buttons">
              <button className="cta-primary" onClick={handleStartTour}>
                <span className="cta-icon">🎯</span>
                <span className="cta-text">Start Guided Tour</span>
                <span className="cta-hint">For recruiters & newcomers</span>
              </button>
              
              <button className="cta-secondary" onClick={handleExploreFree}>
                <span className="cta-icon">🔓</span>
                <span className="cta-text">Explore Freely</span>
                <span className="cta-hint">For the curious hackers</span>
              </button>
            </div>

            <div className="extra-hint">
              <span className="hint-text">💡 Somewhere inside this system is a hidden CTF. Enumeration matters.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomeOverlay;
